function openShare(e) {
  e.stopPropagation();

  const targetShareWidget = e.target.closest('.article-meta-wrap');
  const otherShareWidgets = Array.prototype.filter.call(document.querySelectorAll('.article-meta-wrap'), el => el !== targetShareWidget);

  targetShareWidget.classList.add('active');
  otherShareWidgets.forEach(el => el.classList.remove('active'));
}

function closeShare(e) {
  if (!e.target.closest('.share-widget-toggle') && !e.target.closest('.share-widget')) {
    const articleMetaWrap = document.querySelector('.article-meta-wrap');

    if (articleMetaWrap) {
      articleMetaWrap.classList.remove('active');
    }
  }
}

export default class Share {
  constructor({ el }) {
    this.el = el;
    this.shareWidgetToggles = this.el.querySelectorAll('.share-widget-toggle');
    this.onBodyClick = e => closeShare(e);
    this.onShareClick = e => openShare(e);

    if (!this.shareWidgetToggles) {
      return;
    }

    document.body.addEventListener('click', this.onBodyClick);
    this.shareWidgetToggles.forEach((el) => {
      el.addEventListener('click', this.onShareClick);
    });
  }

  unload() {
    document.body.removeEventListener('click', this.onBodyClick);

    if (this.shareWidgetToggles) {
      this.shareWidgetToggles.forEach((el) => {
        el.removeEventListener('click', this.onShareClick);
      });
    }
  }
}
